export default [
  {
    path: '/main/actives',
    meta: {
      tag: 'list_active',
      name: 'Ativos',
      breadcrumb: 'Ativos'
    },
    component: () => import(/* webpackChunkName: "active-list" */ '@/views/main/settings/stock-registers/active/Index.vue'),
    children: [
      {
        path: '',
        name: 'listactives',
        meta: {
          tag: 'list_active',
          menu: 'settings',
          name: 'Ativos'
        },
        component: () => import(/* webpackChunkName: "active-list" */ '@/views/main/settings/stock-registers/active/List.vue')
      },
      {
        path: '/main/active/add',
        name: 'addactive',
        meta: {
          tag: 'add_active',
          menu: 'settings',
          name: 'Adicionar | Ativo',
          breadcrumb: 'Adicionar Ativo'
        },
        component: () => import(/* webpackChunkName: "active-add" */ '@/views/main/settings/stock-registers/active/Add.vue')
      },
      {
        path: '/main/active/:id',
        name: 'editactive',
        meta: {
          tag: 'edit_active',
          menu: 'settings',
          name: 'Editar | Ativo',
          breadcrumb: 'Editar Ativo'
        },
        component: () => import(/* webpackChunkName: "active-edit" */ '@/views/main/settings/stock-registers/active/Edit.vue')
      },
      {
        path: '/main/link-tracker-simcard/:id',
        name: 'linktrackersimcard',
        meta: {
          tag: 'link_actives',
          menu: 'settings',
          name: 'Vincular | Rastreador e Simcard',
          breadcrumb: 'Vincular Rastreador e Simcard'
        },
        component: () => import(/* webpackChunkName: "linktrackersimcard-edit" */ '@/views/main/settings/stock-registers/active/LinkTrackerAndSimcard.vue')
      },
      {
        path: '/main/link-active-model-simcard/:id',
        name: 'linkactivemodelsimcard',
        meta: {
          tag: 'link_actives',
          menu: 'settings',
          name: 'Vincular | Ativo (Modelo) e Simcard',
          breadcrumb: 'Vincular Ativo (Modelo) e Simcard'
        },
        component: () => import(/* webpackChunkName: "linkactivemodelsimcard-edit" */ '@/views/main/settings/stock-registers/active/LinkActiveModelAndSimcard.vue')
      },
      {
        path: '/main/add-trackers-batch',
        name: 'addtrackersbatch',
        meta: {
          tag: 'add_trackers_batch',
          menu: 'settings',
          name: 'Adicionar | Rastreadores (Em Lote)',
          breadcrumb: 'Adicionar Rastreadores (Em Lote)'
        },
        component: () => import(/* webpackChunkName: "add-trackers-batch" */ '@/views/main/settings/stock-registers/active/AddTrackersBatch.vue')
      },
      {
        path: '/main/add-simcards-batch',
        name: 'addsimcardsbatch',
        meta: {
          tag: 'add_simcards_batch',
          menu: 'settings',
          name: 'Adicionar | Simcards (Em Lote)',
          breadcrumb: 'Adicionar Simcards (Em Lote)'
        },
        component: () => import(/* webpackChunkName: "add-simcards-batch" */ '@/views/main/settings/stock-registers/active/AddSimcardsBatch.vue')
      },
    ]
  }
]
